import { useState, useEffect } from 'react'
import fetchAPI from '../../api/fetchAPI'
import './Footer.scss'

const BUILD_TIME = process.env.REACT_APP_BUILD_TIME

function Footer() {

    const [backendStartTime, setBackendStartTime] = useState(null)

    useEffect(() => {
        fetchAPI.get('/api/status/info')
            .then(data => setBackendStartTime(data.startTime))
            .catch(() => {})
    }, [])

    return(
        <div className="page-footer">
            v12.2023_1{ BUILD_TIME ? ` — built ${BUILD_TIME}` : '' }{ backendStartTime ? ` — backend started ${backendStartTime}` : '' }
        </div>
    )
}

export default Footer

